export enum WebsocketEvent {
  MessageReceived = '.message-received',
}
